import * as stylex from "@stylexjs/stylex";
import { useVideoBuffering } from "@/components/ui/useVideoBuffering";
import "@/design/tokens.stylex";
import { colors, radii } from "@/design/tokens.stylex";
const spin = "x1wc8ddo-B";

// Provider CDNs may refuse a video whose request names our page; React's
// types do not know the attribute yet, so it is spread in.
const NO_REFERRER = {
  referrerPolicy: "no-referrer"
} as Record<string, string>;
/**
 * A silent, looping peek at a video, meant for a hover card: it mounts when
 * the card opens and unmounts when it closes, so nothing plays or downloads
 * until someone hovers, and the browser scales it down to the box. There are
 * no controls; a full player belongs elsewhere. A quiet spinner sits over the
 * poster while the provider's file is still buffering.
 */
export default function HoverVideo({
  src,
  poster,
  width,
  height,
  onDimensions
}: {
  src: string;
  poster?: string | null;
  width: number;
  height: number;
  /** Reports the file's own pixel size once its metadata arrives. */
  onDimensions?: (width: number, height: number) => void;
}) {
  const {
    buffering,
    handlers
  } = useVideoBuffering(true);
  return <span className="x1n2onr6 x1lliihq x14ju556" style={{
    width,
    height
  }}>
      <video src={src} poster={poster ?? undefined} width={width} height={height} muted loop autoPlay playsInline preload="auto" {...NO_REFERRER} aria-label="Video preview" aria-busy={buffering} {...handlers} onLoadedMetadata={event => onDimensions?.(event.currentTarget.videoWidth, event.currentTarget.videoHeight)} style={{
      width,
      height
    }} className="x1lliihq x1wpy2cq xlcwlql x19kjcj4" />
      {buffering ? <span className="x10l6tqk x10a8y8t xrvj5dj x1ku5rj1 x47corl" role="status" aria-label="Loading video">
          <span className="x17z2i9w x17rw0jw x16rqkct xdh2fpr x1y0btm7 xzbo3x7 x11aw6a8 x1aerksh xemfg65 x1esw782 xa4qsjk" />
        </span> : null}
    </span>;
}